import { ErrorContainer } from 'library/styles/text';
import {
  Line, Radio, RadioButton, RadioLabel, SelectRadio,
} from '../../modal/styles';

const Picker = ({
  onChange,
  value,
  error,
  name,
  inputRef,
  options,
}) => {
  const RadioElement = ({ value: currentValue, text, none }) => (
    <>
      <RadioButton
        className="radio-btn"
        isNew={currentValue === text}
        onClick={(e) => {
          e.preventDefault();

          onChange(currentValue);
        }}
      >
        <Radio
          type="radio"
          value={currentValue}
          name="radio"
          checked={currentValue === value}
          onChange={() => {}}
        />
        <RadioLabel />
        {text}
        {currentValue === text ? <i className="icon-plus-big" /> : null}
      </RadioButton>
      <Line none={none} />
    </>
  );

  const renderOption = (items, item) => {
    const { value: currentValue, text } = item;

    return [
      ...items,
      <RadioElement isNew={currentValue === text} value={currentValue} text={text} key={currentValue} />,
    ];
  };

  return (
    <>
      <SelectRadio>
        {options.reduce(renderOption, [])}
      </SelectRadio>
      {
        options.length === 0 ? (<p>Nothing found</p>) : null
      }
      <input type="hidden" ref={inputRef} name={name} />
      {error ? <ErrorContainer>{error.message}</ErrorContainer> : null}
    </>
  );
};

export default Picker;
